module.exports = __webpack_public_path__ + "img/cb9-r-110.997d11df.gif";